import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { selectDataType } from '../../services/types';

interface checkboxType extends selectDataType { isNotActive?: boolean };

export function Checkboxs({ data, className, isSmall, handelCheckbox }: { data: checkboxType[], className?: string, isSmall?: boolean, handelCheckbox: (id: number, value?: boolean) => void }) {
   return (
      <Main className={`checkbox ${className || ''} ${ isSmall ? 'isSmall' : '' }`}>{
         data.map((item, index) => (
            <div 
               key={ index.toString() } className={ item.isNotActive ? 'notActive' : '' } 
               onClick={ () => { handelCheckbox(item.id as number, item.isActive) }} 
               title={ item.name }
            >
               <span>{ item.isActive ? <FontAwesomeIcon icon={ faCheck } /> : null }</span>
               <label>{ item.name }</label>
            </div>
         ))
      }</Main>
   );
}

// ---
const Main = styled.div`
   > div {
      display: inline-flex;
      align-items: center;
      margin-right: 15px;
      margin-top: 7.5px;
      cursor: pointer;
      transition: all .2s ease-in-out;
      
      label {
         cursor: pointer;
      }
      &:hover {
         opacity: 0.8;
      }
      &.notActive {
         color: #c8483e;
      }
   }
   span {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid rgb(220, 220, 220);
      background-color: rgb(245, 245, 245);
      border-radius: 5px;
      margin-right: 10px;
      width: 25px;
      height: 25px;

      svg {
         position: absolute;
         opacity: 0.65;
      }
   }
   &.isSmall {
      text-align: center;

      > div {
         padding-top: 7.5px;
         margin-top: 0;
         
         span {
            width: 17px;
            height: 17px;

            svg {
               font-size: 13px;
            }
         }
         label {
            font-size: 16px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
         }
      }
   }
`;